import { Howl } from 'howler'
import axios from 'axios'

export default {
  install: function install (Vue) {
    const resHost = 'https://static.shikehuyu.com/ddyc/res'
    // Event-bus 相当于简单的store
    const bus = new Vue({
      data () {
        const audioNameList = ['bg', 'wechat', 'hotpot', 'hotpot2', 'cry2', 'typing1', 'typing2', 'car', 'car2', 'cat', 'cheer', 'clock'];
        const audioList = {}
        audioNameList.forEach((name) => {
          audioList[name] = `${resHost}/audios/${name}.mp3`
        })
        return {
          link: '',
          musicOn: true,
          musicLoaded: false,
          audios: {}, // 音频缓冲
          audioList,
          randomTimeout: {}
        }
      },

      methods: {
        getLink() {
          return axios({
            url: 'https://wx.shikehuyu.com/ddyc/link'
          }).then((response) => {
            const result = response.data
            if (result.code === 0) {
              this.link = result.data
            }
          })
        },
        getWxConfig () {
          return axios({
            url: 'https://wx.shikehuyu.com/jssdk',
            params: {
              url: location.href.split('#')[0]
            }
          }).then((response) => {
            const result = response.data
            if (result.code === 0) {
              return result.package
            }
            return null
          })
        },
        configWx (packageData) {
          if (packageData) {
            window.wx.config({
              debug: false,
              appId: packageData.appId, // 必填，公众号的唯一标识
              timestamp: packageData.timestamp, // 必填，生成签名的时间戳
              nonceStr: packageData.nonceStr, // 必填，生成签名的随机串
              signature: packageData.signature, // 必填，签名
              jsApiList: [
                'onMenuShareTimeline', 'onMenuShareAppMessage'
              ] // 必填，需要使用的JS接口列表
            })
            window.wx.ready(() => {
              window.wx.onMenuShareTimeline({
                title: '只要“想见你”，现在就可以出发！', // 分享标题
                link: `${location.href.split('?')[0]}`,
                imgUrl: 'https://static.shikehuyu.com/ddyc/res/share.jpg' // 分享图标
              })
              window.wx.onMenuShareAppMessage({
                title: '只要“想见你”，现在就可以出发！', // 分享标题
                desc: '不要等到遗憾时再出发。', // 分享描述
                link: `${location.href.split('?')[0]}`,
                imgUrl: 'https://static.shikehuyu.com/ddyc/res/share.jpg' // 分享图标
              })
            })
          }
        },
        // 音乐开关
        toggleMusic () {
          this.musicOn = !this.musicOn
          if (this.musicOn) {
            this.musicFadeIn('bg')
          } else {
            this.musicFadeOut('bg')
          }
        },
        // 加载音乐
        loadMusic () {
          if (!this.musicLoaded) {
            this.musicLoaded = true
            Object.keys(this.audioList).forEach((name) => {
              let volume = 1
              if (name.indexOf('hotpot') > -1) volume = .5
              this.audios[name] = new Howl({
                src: this.audioList[name],
                loop: name === 'bg',
                volume
              })
            })
          }
        },
        // 播放音乐
        playMusic (name) {
          if (name in this.audios && this.musicOn) {
            this.audios[name].play()
          }
        },
        // 循环音乐
        loopMusic (name) {
          if (name in this.audios) {
            this.audios[name].loop(true)
          }
        },
        // 音乐淡入
        musicFadeIn (name, from = 0, to = 1, duration = 1000) {
          if (name in this.audios) {
            this.audios[name].fade(from, to, duration)
          }
        },
        // 音乐淡出
        musicFadeOut (name, from = 1, to = 0, duration = 1000) {
          if (name in this.audios) {
            this.audios[name].fade(from, to, duration)
          }
        },
        // 随机播放音效
        randomPlayMusic(name, min, max) {
          this.randomTimeout[name] = setTimeout(() => {
            this.playMusic(name)
            this.randomPlayMusic(name, min, max)
          }, min + Math.random() * (max - min))
        },
        clearRandomTimeout(key) {
          if (key) {
            clearTimeout(this.randomTimeout[key])
          } else {
            Object.values(this.randomTimeout).forEach((timeout) => {
              clearTimeout(timeout)
            })
          }
        }
      }
    })
    bus.getLink()
    bus.getWxConfig().then(bus.configWx)
    /* eslint no-param-reassign: ["error", { "props": false }] */
    Vue.prototype.$bus = bus
  }
}
